/* eslint-disable react/prop-types */
import classes from "./card-partner.module.scss";

import Flex from "@/components-library/layout/flex";
import * as announcementHelper from "@/common/announcement-helper";
function CardPartner({ image, onClick }) {
  return (
    <Flex
      align="center"
      direction="row"
      justify="center"
      className={classes.container}
      onClick={onClick}
    >
      <img
        src={image ? image : announcementHelper.PLACEHOLDER}
        alt="Logo"
        className={classes.image}
      />
    </Flex>
  );
}

export default CardPartner;
